import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Modal } from 'react-bootstrap';

class DeletionModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        ReactDOM.findDOMNode(this.refs.submitButton).focus();
    }

    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
    }

    handleSubmit = () => {
        this.props.handleSubmit();
        this.props.handleClose();
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true} className="modal fade" id="myModal4" tabIndex="-1" role="dialog" aria-labelledby="myModal4Label" aria-hidden="true">
                <div ref="modalBody" className="modal-dialog new-log-entry">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myModalLabel">Delete All Notifications</h4>
                        </div>
                        <div ref="modalBody" className="modal-body">
                            <h4>
                                This action will permanently delete all your notifications.
                            </h4>
                        </div>
                        <div className="modal-footer">
                            <button title="Delete all notifications" ref="submitButton" type="button" className="btn btn-default btn-large" onClick={this.handleSubmit}>OK</button>
                            <button title="Do not delete notifications" ref="closeButton" type="button" className="btn btn-default btn-discrete" onClick={this.handleClose}>Cancel</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

DeletionModal.propTypes = {
    handleClose: PropTypes.func,
    handleSubmit: PropTypes.func
};

export default connect()(DeletionModal);


/** WEBPACK FOOTER **
 ** ./src/app/components/DeletionModal.js
 **/